// extracted by mini-css-extract-plugin
export default {"buttonContainer":"X3kuV0T9TSR9n_O687tx","btn":"hKFeDYUC5Q6hW0nudec1","email":"rie2M1b5sjT0f4MG4KwP","icon":"EH47WSHrgy0CfUMf7DOy"};